import { makeStyles } from "tss-react/mui";

const useSettingsStyles = makeStyles()((theme) => ({
  root: {
    width: "90%",
    margin: `${theme.spacing(1)} auto`,
    paddingBottom: theme.spacing(1),
  },
  moduleName: {
    fontSize: "18px",
    fontWeight: 500,
  },
  top: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  },
  container: {
    display: "flex",
    flexDirection: "column",
  },
  dbListWrapper: {
    backgroundColor: theme.palette.surface.light,
    borderRadius: "8px",
    margin: "8px 16px",
    border: `1px solid ${theme.palette.strokes.defaultGrey}`,
    display: "flex",
    flexDirection: "column",
  },
  dbList: {
    padding: "8px 8px",
  },
  departmentList: {
    padding: "8px 16px",
  },
  fieldsList: {
    paddingBottom: theme.spacing(2),

    "& .MuiTypography-root": {
      fontWeight: 500,
    },
  },
  divider: {
    borderColor: theme.palette.strokes.defaultGrey,
  },
  groupLegend: {
    color: theme.palette.text.primary,
    fontWeight: "500",
    fontSize: "1.125rem",
  },
  settingsGroup: {
    marginLeft: "11px",
    gap: "4px",

    "& .MuiFormControlLabel-label": {
      fontSize: "16px",
    },
  },
  version: {
    color: "white",
    fontSize: "0.9rem",
    textAlign: "right",
  },
  autocomplete: {
    backgroundColor: theme.palette.surface.light,
    color: theme.palette.text.primary,
  },
  infoButton: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },
  chooseVersion: {
    padding: "10px 0",
  },
  versionBtn: {
    paddingBottom: "10px",
    width: "100%",
  },
}));

export default useSettingsStyles;
